import "../../styles/style"
import "../index.scss"
